import { render, staticRenderFns } from "./RedesignExtensionCards.vue?vue&type=template&id=cfde36ca&scoped=true"
import script from "./RedesignExtensionCards.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignExtensionCards.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RedesignExtensionCards.vue?vue&type=style&index=0&id=cfde36ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfde36ca",
  null
  
)

export default component.exports